import { FormFields } from "./fields";

import type { ContactUpdateInputZodSchemaType } from "../../../schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	form: UseFormReturn<ContactUpdateInputZodSchemaType>;
};

export const Form = ({ form }: Props) => {
	return <FormFields form={form} />;
};

Form.displayName = "Form";
